import { c as _c } from "react/compiler-runtime";
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { Card } from '../Card';
import { ChevronLink } from '@/uiComposites/interactive/IconLink';
import { stack } from '@/uiPrimitives/layout/stack';
import { textBlock } from '@/uiPrimitives/typography/text';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { rows } from '@/uiPrimitives/layout/rows';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { imagePlaceholder } from '@/globals/routing/placeholders/imagePlaceholder';
import googlePlayBadgeEn from './google-play-badge-en.svg';
import googlePlayBadgeNl from './google-play-badge-nl.svg';
import appleAppStoreBadgeEn from './apple-appstore-badge-en.svg';
import appleAppStoreBadgeNl from './apple-appstore-badge-nl.svg';
import nieuweWettenAppLogo from './nieuwe-wetten-app-logo.png';
import { translateInline } from '@/globals/translate/translateInline';
import { appPromoImage } from './AppPromoCard.css';
import { WebAPIAppPromo } from '@/globals/webApiTypes/elements/WebAPIPromo';
import { languageCode } from '@/globals/config/localization.config';
import { DOPImage } from '@/uiComposites/media/DOPImage';
import { box } from '@/uiPrimitives/layout/box';
import { linkInlineCSS } from '@/uiComposites/interactive/link.css';
import { H2TextBlock } from '@/uiComposites/typography/headings';
import { gridStack } from '@/uiPrimitives/layout/gridStack';
export type AppPromoCardProps = {
  appleAppStoreUrl: string;
  googlePlayUrl: string;
  href: string;
};
const appStoreMapping = {
  en: {
    apple: appleAppStoreBadgeEn,
    google: googlePlayBadgeEn
  },
  nl: {
    apple: appleAppStoreBadgeNl,
    google: googlePlayBadgeNl
  }
} as const;
const appleAppStoreBadge = appStoreMapping[languageCode].apple;
const googlePlayBadge = appStoreMapping[languageCode].google;
export const AppPromoCard = t0 => {
  const $ = _c(29);
  const {
    href,
    googlePlayUrl,
    appleAppStoreUrl
  } = t0;
  if (languageCode !== "nl") {
    return null;
  }
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(stack({
      rowGap: "3 | h1"
    }));
    t2 = addTestSelector("uiPromoBlockMobileApp");
    t3 = classes(shelf({
      columnGap: "3 | h1",
      gridTemplateColumns: "auto minmax(0, 1fr)",
      alignItems: "start"
    }));
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = translateInline({
      en: "Laws and amendments app",
      nl: "Nieuwe wetten app"
    });
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DOPImage alt={t4} height={nieuweWettenAppLogo.height} width={nieuweWettenAppLogo.width} src={nieuweWettenAppLogo.src} placeholder={imagePlaceholder} className={classes(appPromoImage)} />;
    t6 = classes(stack({
      rowGap: "3 | h1"
    }));
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <H2TextBlock size="h3">{translateInline({
        nl: "Wilt u een melding bij belangrijke wetswijzigingen?",
        en: ""
      })}</H2TextBlock>;
    t8 = <p className={classes(textBlock({
      capLineHeight: "tight"
    }))}>{translateInline({
        nl: "Download de Nieuwe Wetten app, kies uw onderwerp of branche en krijg meldingen als er voor u belangrijke wetswijzigingen of nieuwe regels zijn.",
        en: ""
      })}</p>;
    t9 = classes(rows({
      rowGap: "-2 | smaller",
      columnGap: "0 | p"
    }));
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t7 = $[6];
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = translateInline({
      nl: "Google Play Store: download de Nieuwe Wetten app.",
      en: ""
    });
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <DOPImage alt={t10} height={googlePlayBadge.height} width={googlePlayBadge.width} src={googlePlayBadge.src} style={{
      blockSize: "28px",
      inlineSize: "auto"
    }} />;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== googlePlayUrl) {
    t12 = <DOPLink href={googlePlayUrl} data-link-type="downloadAppFromGoogle">{t11}</DOPLink>;
    $[11] = googlePlayUrl;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = translateInline({
      nl: "Apple App Store: download de Nieuwe Wetten app.",
      en: ""
    });
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <DOPImage alt={t13} height={appleAppStoreBadge.height} width={appleAppStoreBadge.width} src={appleAppStoreBadge.src} style={{
      blockSize: "28px",
      inlineSize: "auto"
    }} />;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== appleAppStoreUrl) {
    t15 = <DOPLink href={appleAppStoreUrl} data-link-type="downloadAppFromApple">{t14}</DOPLink>;
    $[15] = appleAppStoreUrl;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t12 || $[18] !== t15) {
    t16 = <div className={t3}>{t5}<div className={t6}>{t7}{t8}<div className={t9}>{t12}{t15}</div></div></div>;
    $[17] = t12;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = translateInline({
      en: "Read more",
      nl: "Lees meer"
    });
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== href) {
    t18 = <ChevronLink data-link-type="wetswijzigingenApp" href={href}>{t17}</ChevronLink>;
    $[21] = href;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t16 || $[24] !== t18) {
    t19 = <div className={t1} {...t2}>{t16}{t18}</div>;
    $[23] = t16;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Card.Subject>{translateInline({
        nl: "Nieuwe Wetten app",
        en: ""
      })}</Card.Subject>;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t19) {
    t21 = <Card.Item>{t19}{t20}</Card.Item>;
    $[27] = t19;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  return t21;
};
export const ArticleAppPromoCard = () => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(box({
      paddingBlockStart: "1 | h3",
      borderBlockStartStyle: "solid",
      borderColor: "positiveMuted",
      borderWidth: "2px"
    }), gridStack({
      rowGap: "3 | h1",
      alignItems: "start"
    }));
    t1 = classes(stack({
      rowGap: "3 | h1"
    }));
    t2 = addTestSelector("uiPromoBlockMobileApp");
    t3 = classes(shelf({
      columnGap: "3 | h1",
      gridTemplateColumns: "auto minmax(0, 1fr)",
      alignItems: "start"
    }));
    t4 = classes(stack({
      rowGap: "3 | h1"
    }));
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={t1} {...t2}><div className={t3}><div className={t4}><H2TextBlock size="h3">{translateInline({
              nl: "Wilt u een melding bij belangrijke wetswijzigingen?",
              en: ""
            })}</H2TextBlock><p className={classes(textBlock({
            capLineHeight: "tight"
          }))}>{translateInline({
              nl: "Download de Nieuwe Wetten app, kies uw onderwerp of branche en krijg meldingen als er voor u belangrijke wetswijzigingen of nieuwe regels zijn.",
              en: ""
            })}</p></div></div>{languageCode === "nl" && <div className={classes(shelf({
        gap: "2 | h2",
        alignItems: "center"
      }))}><DOPImage alt={translateInline({
          en: "Laws and amendments app",
          nl: "Nieuwe wetten app"
        })} height={nieuweWettenAppLogo.height} width={nieuweWettenAppLogo.width} src={nieuweWettenAppLogo.src} placeholder={imagePlaceholder} className={classes(box({
          size: "9 | asideBlockMargin",
          borderRadius: "8px"
        }))} /><p className={classes(textBlock({}))}>{"Blijf op de hoogte met de gratis "}<DOPLink data-link-type="nieuweWettenAppArticleLink" href="/nieuwe-wetten-app/" className={classes(linkInlineCSS)}>{"Nieuwe Wetten app"}</DOPLink></p></div>}</div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={t0}>{t5}<Card.Subject>{translateInline({
          nl: "Nieuwe Wetten app",
          en: ""
        })}</Card.Subject></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};